import React from "react";
import PageTitle from "../../common/shared/PageTitle";
import ConferenceIcon from "../../common/icons/ConferenceIcon";
import ViewButton from "../../common/buttons/ViewButton";
import { useNavigate } from "react-router-dom";
import { Card, CardBody } from "@material-tailwind/react";
import { DataGrid } from "@mui/x-data-grid";

const ManualAuthorization = () => {
  const navigate = useNavigate();

  const manualList = [
    {
      id: 1,
      name: "Dues Manual List",
      type: "dues",
    },
    { id: 2, name: "Solicitors License Manual List", type: "license" },
    { id: 3, name: "Chamber Manual List", type: "chamber" },
  ];

  const columns = [
    {
      field: "arrayIndex",
      headerName: "ID",
      width: 80,
      valueFormatter: (params) => (params.value + 1).toString(),
    },
    { field: "name", headerName: "Name", flex: 1 },

    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      renderCell: (params) => (
        <ViewButton
          onClick={() =>
            navigate(`/dashboard/authorization/${params.row.type}`)
          }
        />
      ),
    },
  ];

  return (
    <>
      <div className="flex justify-between p-4">
        <div className="flex items-center">
          <PageTitle title={"Manual Authorization"} icon={<ConferenceIcon />} />
        </div>
      </div>

      <Card className="w-full p-6 shadow-xl mb-20">
        <CardBody>
          <DataGrid
            sx={{ border: 0 }}
            rows={manualList.map((row, index) => {
              return { ...row, arrayIndex: index };
            })}
            columns={columns}
          />
        </CardBody>
      </Card>
    </>
  );
};

export default ManualAuthorization;
